enum AppointmentTypeGroup {
  CaregiverCoach = "CAREGIVER_COACH",
  CareNavigation = "CARE_NAVIGATION",
  Dietitian = "DIETITIAN",
  DietitianIntake = "DIETITIAN_INTAKE",
  FamilyMentor = "FAMILY_MENTOR",
  FamilyMentorIntake = "FAMILY_MENTOR_INTAKE",
  MealSupport = "MEAL_SUPPORT",
  Medical = "MEDICAL",
  MedicalIntake = "MEDICAL_INTAKE",
  PeerMentor = "PEER_MENTOR",
  PeerMentorIntake = "PEER_MENTOR_INTAKE",
  Psych = "PSYCH",
  PsychIntake = "PSYCH_INTAKE",
  RecoveryCoach = "RECOVERY_COACH",
  Therapy = "THERAPY",
  TherapyIntake = "THERAPY_INTAKE",
}

enum AppointmentTypeLabel {
  DietitianIntake = "Dietitian Intake",
  TherapyIntake = "Therapy Intake",
}

// Program names and treatment types
enum ProgramName {
  EquipAdult = "Equip Adult",
  EquipTreatment = "Equip treatment",
  OpenCareModel = "Open Care Model",
  RelapsePrevention = "Relapse prevention",
  TransitionTrack = "Transition Track",
}

enum SchedulePermissionTreatmentType {
  CbtE = "CBT-E",
  FBT = "FBT",
  OCM = "OCM",
  RelapsePrevention = "RELAPSE-PREVENTION",
  TransitionTrack = "TRANSITION",
}

enum SchedulePermissionActionType {
  Allow = "ALLOW",
  Cancel = "CANCEL",
  Default = "DEFAULT",
  Optional = "OPTIONAL",
}

// Program name to treatment type mapping
const ProgramNameToTreatmentTypeMapper: Record<
  ProgramName,
  SchedulePermissionTreatmentType
> = {
  [ProgramName.EquipAdult]: SchedulePermissionTreatmentType.CbtE,
  [ProgramName.EquipTreatment]: SchedulePermissionTreatmentType.FBT,
  [ProgramName.OpenCareModel]: SchedulePermissionTreatmentType.OCM,
  [ProgramName.RelapsePrevention]:
    SchedulePermissionTreatmentType.RelapsePrevention,
  [ProgramName.TransitionTrack]:
    SchedulePermissionTreatmentType.TransitionTrack,
};

export {
  AppointmentTypeGroup,
  AppointmentTypeLabel,
  ProgramName,
  ProgramNameToTreatmentTypeMapper,
  SchedulePermissionActionType,
  SchedulePermissionTreatmentType,
};
